/**
 * StopsScreen — Driver stop history and 7-day totals
 * Extracted from DriverApp.jsx (V2-03.12i)
 * Reads /api/driver/my-stops, displays weekly totals + daily breakdown.
 */

import React, { useState, useEffect } from 'react';
import { C, FONT, GLASS, GLASS_STRONG } from '../driver-tokens.js';
import { api } from '../auth/driver-session.js';

interface StopDay {
  id: string | number;
  log_date: string;
  stops: number;
  miles: number;
  stop_bonus: string | number;
}

interface StopsData {
  weekly_totals?: { stops: number; miles: number; stop_bonus: number };
  days?: StopDay[];
}

function StopsScreen() {
  var [data, setData] = useState<StopsData | null>(null);
  var [loading, setLoading] = useState(true);

  useEffect(function() {
    api<StopsData>("/api/driver/my-stops").then(function(d) {
      setData(d);
      setLoading(false);
    });
  }, []);

  if (loading) return React.createElement("div", { style: { padding: 40, textAlign: "center" } },
    React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 14, color: C.silver } }, "Loading...")
  );

  return React.createElement("div", { style: { padding: 20, paddingBottom: 100 } },
    React.createElement("div", { style: { fontFamily: FONT.headline, fontSize: 20, color: C.text, marginBottom: 16 } }, "My Stops"),

    data && data.weekly_totals && React.createElement("div", { style: { ...GLASS_STRONG, padding: 20, marginBottom: 16, borderRadius: 16 } },
      React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 11, color: C.gold, textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 12 } }, "7-Day Totals"),
      React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, textAlign: "center" } },
        React.createElement("div", null,
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 28, color: C.text } }, data.weekly_totals.stops),
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 10, color: C.textMuted } }, "Stops")
        ),
        React.createElement("div", null,
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 28, color: C.text } }, data.weekly_totals.miles),
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 10, color: C.textMuted } }, "Miles")
        ),
        React.createElement("div", null,
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 28, color: data.weekly_totals.stop_bonus > 0 ? C.gold : C.text } }, "$" + data.weekly_totals.stop_bonus.toFixed(2)),
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 10, color: C.textMuted } }, "Bonus")
        )
      )
    ),

    ((data && data.days) || []).map(function(day) {
      return React.createElement("div", { key: day.id, style: { ...GLASS, padding: 14, marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" } },
        React.createElement("div", null,
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 13, color: C.text } }, new Date(day.log_date + "T12:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })),
          React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 11, color: C.silver } }, day.stops + " stops \u2022 " + Math.round(day.miles) + " mi")
        ),
        parseFloat(String(day.stop_bonus)) > 0 && React.createElement("div", { style: { fontFamily: FONT.mono, fontSize: 14, color: C.gold, fontWeight: 700 } }, "+$" + parseFloat(String(day.stop_bonus)).toFixed(2))
      );
    })
  );
}

export default StopsScreen;
